import tw from 'twin.macro';

export const PageWrapper = tw.div`
flex font-display! h-screen
`;

// styles for the first column of the page.
export const ColumnOne = tw.div`w-1/2 pl-20 pr-24 text-white pt-16 xl:pt-24 pb-20
 flex justify-center items-center relative bg-adminprimary`;

export const InformationWrapper = tw.div`flex my-6`;

export const InformationIcon = tw.i`text-5xl rounded-xl w-24 h-24 flex pt-5 justify-center
 text-center bg-adminglass`;

export const InformationTextWrapper = tw.div`ml-8 flex flex-col justify-between`;

export const InformationTextHeader = tw.h3`text-xl font-semibold`;

export const InformationTextDescription = tw.p`mb-6 mt-4 w-4/6 font-thin`;

// styles for the bubbles on the first column
export const BubbleOne = tw.div`w-6 h-6 rounded-full border-admintertiary border top-0 ml-4`;

export const BubbleTwoOutter = tw.div`p-4 w-2 h-2 rounded-full relative border-blue-600 
border flex justify-center items-center`;

export const BubbleTwoInner = tw.div`bg-adminglass w-5 h-5 rounded-full absolute`;

export const BubbleThree = tw.div`w-14 h-14 ml-96 rounded-full border-admintertiary border`;

export const BottomBubbles = tw.div`
 flex justify-between
`;

// styles for the second column of the page.
export const ColumnTwo = tw.div`w-1/2 xl:pt-24 pt-16 px-20`;

export const HeadingWrapper = tw.div``;

export const HeadingOne = tw.h3`text-4xl text-gray-800 font-medium`;

export const HeadingTwo = tw.h4`text-4xl font-extralight text-adminsecondary mt-4 mb-6`;

export const HeadingThree = tw.h2`text-5xl tracking-tighter! text-adminsecondary font-black`;

export const HeadingBar = tw.div`bg-admintertiary w-2/12 mt-2 rounded-lg`;

export const Form = tw.form`flex flex-col w-11/12 my-16`;

export const Label = tw.label`text-lg mb-1`;

export const Input = tw.input`px-5 py-3 bg-admintertiary mb-4 rounded-md`;

export const ShowPassword = tw.h4`-mt-3 cursor-pointer! font-semibold 
text-gray-600 text-sm select-none`;

export const LoginButton = tw.button`px-20 mt-10 py-4 bg-adminsecondary text-center 
text-xl font-semibold mx-auto rounded-md text-white`;

export const ColumnTwoFooter = tw.p`text-center font-extralight`;
